import { render, staticRenderFns } from "./BusinessesBanner.vue?vue&type=template&id=598f0980&scoped=true&"
import script from "./BusinessesBanner.vue?vue&type=script&lang=js&"
export * from "./BusinessesBanner.vue?vue&type=script&lang=js&"
import style0 from "./BusinessesBanner.vue?vue&type=style&index=0&id=598f0980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f0980",
  null
  
)

export default component.exports